import { Link } from 'react-router-dom'
import { usePurchases } from '@/hooks/usePurchases'
import { routes } from '@/routes'
import { BagCheckIcon } from '@/components/ui/icons'
import { AddPurchasePopover } from './AddPurchasePopover'
import { Logo } from './Logo'
import { SearchBar } from './SearchBar'
import { UserMenu } from './UserMenu'

/**
 * Barra verde fixa no topo.
 *
 * A composição é a mesma com ou sem sessão — quem muda de conteúdo é o menu da
 * direita. "Adicionar compra" continua disponível para visitantes: clicar
 * dispara a tarja de aviso, que é o caminho previsto para levá-los ao login.
 *
 * Até `md` o cabeçalho é uma linha só — selo, busca e sanduíche —, e os dois
 * botões de compra migram para dentro do menu (ver UserMenu).
 */
export function Header() {
  const { purchases } = usePurchases()

  return (
    <header className="sticky top-0 z-40 bg-brand">
      <div className="mx-auto flex h-14 max-w-[1200px] items-center gap-3 px-4 sm:gap-6">
        <Logo sealUntilMd />

        <div className="flex min-w-0 flex-1">
          <SearchBar />
        </div>

        <div className="flex shrink-0 items-center gap-3 sm:gap-4">
          <div className="hidden md:block">
            <AddPurchasePopover />
          </div>

          <Link
            to={routes.shoppingList}
            aria-label={
              purchases.length > 0
                ? `Já comprados (${purchases.length} ${purchases.length === 1 ? 'item' : 'itens'})`
                : 'Já comprados'
            }
            className="relative hidden size-9 items-center justify-center rounded text-white transition-opacity hover:opacity-80 md:flex"
          >
            <BagCheckIcon className="size-6" />
            {purchases.length > 0 && (
              <span className="absolute -right-0.5 -top-0.5 flex min-w-4 items-center justify-center rounded-full bg-accent px-1 text-[10px] font-bold leading-4 text-ink">
                {purchases.length > 99 ? '99+' : purchases.length}
              </span>
            )}
          </Link>

          <UserMenu />
        </div>
      </div>
    </header>
  )
}
